<template>
	<div>
		<slot>Set content as inline template.</slot>
	</div>
</template>

<script>
	export default {
		props: ['grade'],
		data() {
			return {
				selected: 0,
				items: [],
				data: []
			}
		},
		methods: {
			gotoCollection() {
				window.open('https://nakup.rokus-klett.si/znam-za-vec');
			},
			gotoStore(item) {
				window.open(item.url, '_blank');
			}
		},
		mounted() {
			axios.get(this.route('api.list')).then(response => {
				this.data = response.data;
				this.selected = this.grade;
			});
		},
		watch: {
			selected: function (newValue) {
				for (var i = 0; i < this.data.length; i++) {
					if (this.data[i].class == this.selected) {
						this.items = this.data[i].list;
					}
				}
			}
		}
	}

</script>



// WEBPACK FOOTER //
// resources/assets/js/components/Browser.vue